import { useEffect } from 'react';
import { resetSwConfigReady } from 'services/serviceWorker/swConfigReady';
import { logoutClient } from 'shared/domain/logout/logoutClient';

/** Resets the store when the user signs out (in any tab); the worker has to be configured again. */
export function useResetOnLogout(reset: () => void): void {
  useEffect(
    () =>
      logoutClient.onLoggedOut(() => {
        resetSwConfigReady();
        reset();
      }),
    [reset]
  );
}
